import { Dayjs } from "dayjs";
import { SalesGranularity } from "./salesPeriod.ts";

const euros = new Intl.NumberFormat("it-IT", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
  useGrouping: "always",
});

const compactEuros = new Intl.NumberFormat("it-IT", {
  style: "currency",
  currency: "EUR",
  notation: "compact",
  maximumFractionDigits: 1,
});

const integers = new Intl.NumberFormat("it-IT", { useGrouping: "always" });

const signedEuros = new Intl.NumberFormat("it-IT", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
  useGrouping: "always",
  signDisplay: "exceptZero",
});

const signedIntegers = new Intl.NumberFormat("it-IT", {
  useGrouping: "always",
  signDisplay: "exceptZero",
});

const percent = new Intl.NumberFormat("it-IT", {
  style: "percent",
  maximumFractionDigits: 1,
});

const signedPercent = new Intl.NumberFormat("it-IT", {
  style: "percent",
  maximumFractionDigits: 0,
  signDisplay: "exceptZero",
});

const dayAndMonth = new Intl.DateTimeFormat("it-IT", {
  day: "numeric",
  month: "short",
});

const dayMonthAndYear = new Intl.DateTimeFormat("it-IT", {
  day: "numeric",
  month: "short",
  year: "numeric",
});

const monthAndYear = new Intl.DateTimeFormat("it-IT", {
  month: "short",
  year: "2-digit",
});

const longMonthAndYear = new Intl.DateTimeFormat("it-IT", {
  month: "long",
  year: "numeric",
});

export function formatEuros(cents: number): string {
  return euros.format(cents / 100);
}

export function formatCompactEuros(cents: number): string {
  return compactEuros.format(cents / 100);
}

export function formatCount(count: number): string {
  return integers.format(count);
}

export function formatPercent(ratio: number): string {
  return percent.format(ratio);
}

export function formatChange(ratio: number): string {
  return signedPercent.format(ratio);
}

export function formatDay(date: Dayjs): string {
  return dayMonthAndYear.format(date.toDate());
}

export function formatPeriod({ from, to }: { from: Dayjs; to: Dayjs }): string {
  return `${formatDay(from)} – ${formatDay(to)}`;
}

export function formatMonth(month: Dayjs): string {
  return longMonthAndYear.format(month.toDate());
}

export function formatBucketTick(
  start: Dayjs,
  granularity: SalesGranularity,
): string {
  return granularity === SalesGranularity.Month
    ? monthAndYear.format(start.toDate())
    : dayAndMonth.format(start.toDate());
}

export function formatBucket(
  bucket: { start: Dayjs; end: Dayjs },
  granularity: SalesGranularity,
): string {
  if (granularity === SalesGranularity.Day) return formatDay(bucket.start);
  if (granularity === SalesGranularity.Month) return formatMonth(bucket.start);
  return `${dayAndMonth.format(bucket.start.toDate())} – ${formatDay(bucket.end)}`;
}

export function formatSignedEuros(cents: number): string {
  return signedEuros.format(cents / 100);
}

export function formatSignedCount(count: number): string {
  return signedIntegers.format(count);
}

export function describeSelectedOptions(
  selected: string[],
  labelOf: (value: string) => string,
  nothingSelected: string,
): string {
  if (selected.length === 0) return nothingSelected;
  if (selected.length === 1) return labelOf(selected[0]);
  return `${selected.length} selezionati`;
}
